import {useRef, useEffect, useState} from "react";
import {Table} from "antd";
import styles from "./AntdTable.module.css"

export const AntdTable = ({
	total,
	columns,
	data,
	loading,
	scroll,
	currentPage,
	tableSize,
	pageSize,
	onChange,
	tableProps,
	rowSelection,
	pagination,
}) => {
	const wrapperRef = useRef(null);
	const [scrollY, setScrollY] = useState(scroll || 300);

	const isColumnsLimitExceeded = columns.length > 10;

	useEffect(() => {
		const updateScrollY = () => {
			const wrapper = wrapperRef.current;
			if (!wrapper) {
				return;
			}

			const {top, width} = wrapper.getBoundingClientRect();
			if (width === 0) {
				return;
			}

			const visibleTop = Math.max(top, 0);
			setScrollY(Math.max(window.innerHeight - visibleTop - 160, 200));
		};
		updateScrollY();
		window.addEventListener("resize", updateScrollY);

		const observer = new IntersectionObserver(([entry]) => {
			if (entry.isIntersecting) {
				updateScrollY();
			}
		});
		observer.observe(wrapperRef.current);

		return () => {
			window.removeEventListener("resize", updateScrollY);
			observer.disconnect();
		};
	}, [loading]);


	return(
    <div ref={wrapperRef} className={`${styles.tableWrapper} ${isColumnsLimitExceeded ? styles.smallerHeaderRow : ""}`}>
        <Table
            columns={columns}
            dataSource={data}
            {...tableProps}
            size={tableSize}
            loading={loading}
            onChange={onChange}
            rowSelection={rowSelection}
            pagination={
                pagination || {
                    total: total,
                    current: currentPage,
                    pageSize: pageSize ? pageSize : 50
                }
            }
            scroll={{y: scrollY}}
            data-testid="antd-table-container"
        />
    </div>
    )
};
